import React from "react";
import { useDispatch } from "react-redux";

import { initiatePPTUpload, updatePPTUploadProgress, createStoryboardFromPPT } from 'actions/storyboard';

import cx from 'classnames';
import shortid from 'shortid';

import { Button } from 'react-bootstrap';

import { FileUploadButton } from 'components/Buttons';

import styles from './pptxButton.module.scss';

export function PPTXButton({ className, onClose }) {
  const dispatch = useDispatch();

  const handleUploadStart = (instances) => {
    instances.forEach(instance => {
      const upload = {
        id: instance.files[0].id,
        name: instance.files[0].name.replace('.pptx', ''),
        type: instance.files[0].type,
        size: (instance.files[0].size / 1048576),
        progress: 0,
        instance: instance
      }

      dispatch(initiatePPTUpload(upload));
    });

    if (onClose) {
      onClose();
    }
  }

  const handleUploadProgress = (file, progress) => {
    dispatch(updatePPTUploadProgress(file.id, progress));
  }

  const handleUploadComplete = (info, file) => {
    if (info) {
      const request = {
        name: file.name,
        signedUrl: info.signedUrl
      }

      dispatch(createStoryboardFromPPT(file.id, request));
    }
  }

  return (
    <FileUploadButton
      className={cx(styles.upload, className)}
      name="Import PPT"
      multiple={false}
      accept='.pptx'
      onStart={handleUploadStart}
      onProgress={handleUploadProgress}
      onComplete={handleUploadComplete}
      >
      <span className={styles.importPPT}>
        <i className={cx('cleverstory-pptx')} />
        <span>PPT</span>
      </span>
    </FileUploadButton>
  )
}